import { render, staticRenderFns } from "./ResetCertificationView.vue?vue&type=template&id=4f697535&"
import script from "./ResetCertificationView.vue?vue&type=script&lang=js&"
export * from "./ResetCertificationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports